import React from "react";
import GitHubCalendar from "react-github-calendar";
import { TbLetterC } from "react-icons/tb"
import { CgCPlusPlus } from "react-icons/cg";
import {
  SiPython,
  SiGit,
  SiPytorch,
  SiTensorflow,
  SiKeras,
  SiQt,
  SiVisualstudiocode,
  SiLinux,
  SiWindows,
  SiOpencv,
  SiDocker
} from "react-icons/si";
import { Animate } from "react-simple-animate";
import './styles.scss';

const Skills = () => {
  return (
    <section id="skills" className="skills">

      <div className="skills__content-wrapper">
        
        <div className="skills__content-wrapper__inner-content">
            <Animate
              play
              duration={1}
              delay={0.3}
              start={{
                transform: "translateX(-200px)",
              }}
              end={{
                transform: "translateX(0px)",
              }}
            >
              <div className="skills__content-wrapper__inner-content__buttons"><h1> Professional Skillset </h1></div>
              <div className="skills__content-wrapper__inner-content__buttons">
                    <button><SiPython size={30} /></button>
                    <button><TbLetterC size={30} /></button>
                    <button><CgCPlusPlus size={30}/></button>

              </div>
              <div className="skills__content-wrapper__inner-content__buttons">
                    <button><SiPytorch size={30} /></button>
                    <button><SiTensorflow size={30} /></button>
                    <button><SiKeras size={30} /></button>
                    <button><SiOpencv size={30} /></button>
                    <button><SiQt size={30}/></button>
                    <button><SiDocker size={30}/></button>
              </div>

              <div className="skills__content-wrapper__inner-content__buttons"><h1> Tools I use </h1></div>

              <div className="skills__content-wrapper__inner-content__buttons">
                    <button><SiLinux size={30} /></button>
                    <button><SiWindows size={30} /></button>
                    <button><SiGit size={30}/></button>
                    <button><SiVisualstudiocode size={30}/></button>
              </div>

              <div className="skills__content-wrapper__inner-content__buttons"><h1> Days I code </h1></div>
              
              <div className="skills__content-wrapper__inner-content__buttons">
              <GitHubCalendar username="myatmyintzuthin" blockSize={15} blockMargin={5} color="grey" fontSize={16} />
              </div>
            </Animate>
          </div>
      </div>
    </section>
  );
};

export default Skills;
